import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { AllocationSortOrder } from "@/helpers/allocations";
import { ChevronUp } from "lucide-react";

interface ThProps {
  children?: React.ReactNode;
  className?: string;
  sortKey?: string;
  currentSort?: string;
  currentOrder?: AllocationSortOrder;
  onSort?: (sortKey: string) => void;
}

export const Th = ({ children, className, sortKey, currentSort, currentOrder, onSort }: ThProps) => {
  const isSortable = sortKey && onSort;
  const isActive = isSortable && currentSort === sortKey;

  const handleClick = () => {
    if (isSortable) {
      onSort(sortKey);
    }
  };

  return (
    <th
      className={cn(
        "bg-slate-100 px-4 py-3 text-left text-xs font-medium whitespace-nowrap",
        isSortable && "cursor-pointer transition-colors select-none hover:bg-slate-200/70",
        className
      )}
      onClick={handleClick}
    >
      <span className="inline-flex items-center gap-1">
        {children}
        {isActive && (
          <ChevronUp
            className={cn(
              "h-3.5 w-3.5 text-slate-500 transition-transform duration-200",
              currentOrder === "desc" && "rotate-180"
            )}
          />
        )}
      </span>
    </th>
  );
};

export const Td = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <td className={cn("px-4 py-2 align-top text-sm", className)}>{children}</td>;
};

export const TimeInput = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  return <Input type="time" value={value} onChange={(e) => onChange(e.target.value)} className="h-8 w-28 text-sm" />;
};

export const NumberInput = ({ value, onChange }: { value: number; onChange: (value: number) => void }) => {
  return (
    <Input
      type="number"
      min={0}
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value, 10) || 0)}
      className="h-8 w-20 text-center text-sm"
    />
  );
};
